module.exports = __webpack_public_path__ + "static/bernard_character_wishmastree_01-2c5aab71688fac9379dec9bf8d47e6f3.jpg";